import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

/*
 * StrictMode intentionally omitted here.
 * In development StrictMode runs effects twice, which makes local
 * Lighthouse/network testing noisier. Production behavior is unchanged.
 */
root.render(<App />);
